const COORD_NUMBER = '(-?\\d+(?:\\.\\d+)?)'

/** Decimal degrees: "12.9716, 77.5946" or "12.9716 77.5946" (comma or whitespace separator). */
const DECIMAL_COORDINATES_PATTERN = new RegExp(`^\\s*${COORD_NUMBER}\\s*[,\\s]\\s*${COORD_NUMBER}\\s*$`)

/** Input resembles coordinates but may be incomplete or out of range. */
const COORDINATE_LIKE_PATTERN = new RegExp(
  `^\\s*${COORD_NUMBER}\\s*(?:[,\\s]\\s*${COORD_NUMBER}?)?\\s*$`
)

export type ParsedDecimalCoordinates = {
  lat: number
  lon: number
}

export const looksLikeCoordinates = (input: string): boolean => {
  const trimmed = input.trim()
  if (!trimmed) {
    return false
  }
  return COORDINATE_LIKE_PATTERN.test(trimmed)
}

export const parseDecimalCoordinates = (input: string): ParsedDecimalCoordinates | null => {
  const trimmed = input.trim()
  const match = trimmed.match(DECIMAL_COORDINATES_PATTERN)
  if (!match) {
    return null
  }

  const lat = Number.parseFloat(match[1])
  const lon = Number.parseFloat(match[2])

  if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
    return null
  }
  if (lat < -90 || lat > 90) {
    return null
  }
  if (lon < -180 || lon > 180) {
    return null
  }

  return { lat, lon }
}
